import { useEffect, useState } from 'react';
import { API } from '../../api';

// Specs que se pueden correr desde Label. El endpoint es staff-only, así que el
// hook no se activa sin `enabled`. Con cuál clasificar se decide en cada
// corrida; `defaultSpec` es sólo la sugerencia global que manda el servidor.
export default function useAISpecOptions(enabled) {
    // Un solo estado, escrito nada más que desde los callbacks de la promesa:
    // marcar "cargando" desde el cuerpo del efecto encadena renders de más.
    // `enabled` sale de is_staff y no cambia mientras la pantalla vive, así que
    // alcanza con arrancar en cargando cuando ya viene en true.
    const [state, setState] = useState({
        specs: [], defaultSpec: '', loading: Boolean(enabled), error: '',
    });

    useEffect(() => {
        if (!enabled) return undefined;

        const controller = new AbortController();
        // Sólo los utilizables: los legacy no se pueden correr y el backend los
        // rechazaría igual.
        API.get('/ai/specs/?usable_only=true', { signal: controller.signal })
            .then(({ data }) => {
                setState({
                    specs: data?.specs ?? [],
                    defaultSpec: data?.default_spec ?? '',
                    loading: false,
                    error: '',
                });
            })
            .catch((e) => {
                if (e?.name === 'AbortError') return;
                // Sin lista no se puede clasificar: el spec es obligatorio y
                // sólo se puede elegir de acá.
                setState({
                    specs: [],
                    defaultSpec: '',
                    loading: false,
                    error: e?.response?.data?.detail ?? 'ai_specs_unavailable',
                });
            });

        return () => controller.abort();
    }, [enabled]);

    return state;
}
